export default function pluralize(initialValue: unknown, singular: unknown, plural: unknown) {
  const initial = Number(initialValue);
  if (initial === 1) {
    return singular;
  }
  return plural;
}
